import React from 'react';

export default function Copyright({ children }) {
  return children ? (
    <figcaption className="bonn-image-copyright">© {children}</figcaption>
  ) : null;
}
